import * as React from 'react';
import {
    Audit,
    Certification,
    Issue,
    IssueForReview,
    Project,
    ScoringReport, Section
} from '../../../../store/projects/commonTypes';
import Loading from "../../../application/Loading";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography, TextField, Autocomplete, Button, ToggleButton, Switch,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Option} from "../../../../store/common-values";
import {IncidentType} from "../../../../store/incidents";
import {incidentTypeOptions} from "../../../../utils/utils";
import AddIcon from "@mui/icons-material/Add";
import {Dangerous, Info, Warning} from "@mui/icons-material";
import Stack from "@mui/material/Stack";

export interface AuditIssuesProps {
    issues: IssueForReview[];
    scoringReport: ScoringReport | null
    isLoading: boolean;
}

export interface AuditIssuesState {
    filter: string;
    showOnlyWithData: boolean;
}

export default class AuditIssues extends React.Component<AuditIssuesProps, AuditIssuesState> {

    constructor(props) {
        super(props);

        this.state = {
            filter: '',
            showOnlyWithData: true
        }
    }

    private getIssueForReview(issue: Issue) {
        const issueForReviews = this.props.issues.filter(_ => _.issueId == issue.id);
        return issueForReviews.length > 0 ? issueForReviews[0] : null;
    }

    private renderIssue(issue: Issue) {
        const issueForReview = this.getIssueForReview(issue);

        return (
            <div className="row">
                <div className="col-sm-6 d-flex align-items-center mb-3">
                    {issue.code}: {issue.name}
                </div>
                <div className="col-sm-6 d-flex align-items-center justify-content-end mb-3">
                    <Stack direction="row" gap={1} className={`issue-status-${issueForReview?.resultId}`}>
                        {issueForReview?.resultId == 283210000 ? (
                            <Dangerous/>
                        ) : (issueForReview?.resultId == 283210001 ? (
                            <Warning/>
                        ) : (issueForReview?.resultId == 283210002 ? (
                            <Info/>
                        ) : <span className="data-value">Ingen kommentarer</span>))}
                        {issueForReview?.result}
                    </Stack>
                </div>
                {issueForReview?.comment && (
                    <div className="col-sm-12 d-flex align-items-center mb-3">
                        <p className="data-value">{issueForReview?.comment}</p>
                    </div>
                )}
            </div>
        );
    }

    private filterSection(section: Section): boolean {
        return section.issues.filter(_ => this.filterIssue(_)).length > 0;
    }

    private filterIssue(issue: Issue): boolean {
        const filter = this.state.filter?.toLowerCase();
        const showOnlyWithComments = this.state.showOnlyWithData == true;

        const filterSuccess = !filter || `${issue.code} ${issue.name}`.toLowerCase().indexOf(filter) >= 0;

        if (!filterSuccess) return false;

        if (!showOnlyWithComments) return true;

        const issueForReview = this.getIssueForReview(issue);

        return !!issueForReview?.result;
    }

    public render() {
        return (
            <React.Fragment>
                {this.props.isLoading ? (
                    <Loading/>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-sm-6 mb-4 d-flex align-items-center">
                                <h4> Emne-revisjon</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 mb-3">
                                <TextField
                                    label="Søk"
                                    type="search"
                                    fullWidth
                                    variant="standard"
                                    value={this.state.filter}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({filter: event.target.value})}
                                />
                            </div>
                            <div className="col-sm-6 mb-3 d-flex align-items-center justify-content-end">
                                <Switch checked={this.state.showOnlyWithData}
                                        onChange={e => this.setState({showOnlyWithData: e.target.checked})}/>
                                <label>Vis kun med kommentarer</label>
                            </div>
                        </div>
                        {this.props.scoringReport?.sections.filter(_ => this.filterSection(_)).map(section => (
                            <Accordion className="mb-3" defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                    <Typography>{section.name}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="row">
                                        {section.issues.filter(_ => this.filterIssue(_)).map(issue => this.renderIssue(issue))}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </>
                )}
            </React.Fragment>
        )
            ;
    }
}